import React from 'react';

const AffiliatesHome = () => {
  return <div>AffiliatesHome</div>;
};

export default AffiliatesHome;
